import { ConfigurationCard, ExistingGroupOption } from 'src/generated-types/configure-positions'

export const buildExistingGroups = (cards: ConfigurationCard[]): ExistingGroupOption[] => {
  const byId = new Map<number, ExistingGroupOption>()
  cards.forEach(card => {
    if (!card.groupId || card.groupId <= 0 || !card.groupName || byId.has(card.groupId)) return
    byId.set(card.groupId, {
      key: card.key,
      id: card.groupId,
      name: card.groupName,
      drawingId: card.drawingId,
      drawingNumber: card.drawingNumber,
    })
  })
  return [...byId.values()].sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }))
}

export const findGroupByName = (groups: ExistingGroupOption[], name: string) => {
  const wanted = name.trim().toLowerCase()
  return wanted ? groups.find(group => group.name.trim().toLowerCase() === wanted) : undefined
}

export const filterGroups = (groups: ExistingGroupOption[], input: string, suggestedName: string) => {
  const wanted = input.trim().toLowerCase()
  if (!wanted || input === suggestedName) return groups
  return groups.filter(group => group.name.toLowerCase().includes(wanted))
}
